module.exports = __webpack_public_path__ + "img/collection_fish_2.98e3ae93.png";